import { FieldTracker, Quote, QuoteFeedEvent } from '@benzinga/quotes-v3-manager';
import { Subscribable, SubscribableMultiplexer, SubscriberId } from '@benzinga/subscribable';
import { QuotesV3FieldsManager } from '@benzinga/quotes-v3-fields-manager';
import { Session } from '@benzinga/session';

type SubscriberUniqueId = unknown;

export class FeedMultiplexer extends SubscribableMultiplexer<QuoteFeedEvent> {
  private fieldsTracker: FieldTracker;
  constructor(subscribables: [SubscriberUniqueId, Subscribable<QuoteFeedEvent>][], session: Session) {
    super(subscribables);
    this.fieldsTracker = new FieldTracker(
      this.onFieldsUpdate,
      session.getManager(QuotesV3FieldsManager).getFieldIds() as Set<keyof Quote>,
    );
  }
  public override add(id: SubscriberUniqueId, subscribable: Subscribable<QuoteFeedEvent>): void {
    super.add(id, subscribable);
    this.subscriptions?.get(id)?.update(this.onDispatch, this.fieldsTracker.getFields());
  }
  protected onUpdate(id: SubscriberId, args: Set<keyof Quote>): void {
    this.fieldsTracker.onUpdate(id, args);
  }

  protected onSubscribe(id: SubscriberId, args: Set<keyof Quote>): void {
    this.fieldsTracker.onSubscribe(id, args);
  }

  protected onUnsubscribe(id: SubscriberId): void {
    this.fieldsTracker.onUnsubscribe(id);
  }

  private onFieldsUpdate = (fields: Set<string>): void => {
    this.subscriptions?.forEach(sub => sub.update(this.onDispatch, fields));
  };
}
